<style lang="scss" scoped>
.navbar-dropdown {
  padding: 24px;
}
.divider {
  width: 100%;
  height: 1px;
  background: var(--border-color);
  margin: 23px 0;
}
.progress {
  .bar {
    height: 5px;
    width: 100%;
    position: relative;
    background: var(--border-color);
    border-radius: 2px;
    .fill {
      border-radius: 2px;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background: var(--primary);
    }
  }
}
.workspaces,
.items,
.logout {
  margin: 0 -24px;
}
.logout {
  margin-bottom: -24px;
}

.workspaces {
  .title {
    padding: 0 24px;
    margin-bottom: 15px;
    display: block;
    font-size: 16px;
  }
  .workspace {
    padding: 8px 24px;
    cursor: pointer;
    display: flex;
    flex-flow: row;
    transition: background-color 0.15s ease-in-out;
    .avatar {
      height: 32px;
      width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      flex: none;
    }
    .company-text {
      max-width: 150px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    &:hover {
      background-color: #f8fafb;
    }
  }
}
</style>
<template>
  <dropdown-layout class="col-3 d-flex align-items-center" width="356px" :openable="!$root.isMobile">
    <template v-slot:handle>
      <a href="JavaScript:void(0);" class="d-flex flex-row ml-auto align-items-center">
        <el-avatar :user="user"></el-avatar>
        <slot name="label"></slot>
      </a>
    </template>

    <template v-slot:items>
      <div class="navbar-dropdown" v-if="!$root.isMobile">
        <div class="d-flex flex-row mb-30">
          <el-avatar :user="user" class="mr-15 a-40"></el-avatar>
          <div class="d-flex flex-column">
            <span v-if="user" class="fs-16 fw-b">{{ user.first_name }} {{ user.last_name }}</span>
            <router-link v-if="user && !user.read_only && !min" class="fs-12 fw-n" :to="{ name: 'profile-settings', params: { upload_foto: true } }">
              {{ $t('forms.labels.upload_foto') }}
            </router-link>
          </div>
        </div>
        <div class="progress" v-if="workspace && workspace.can_edit && !min">
          <div class="bar mb-15">
            <div
              class="fill"
              :style="{
                width: `${(workspace.plan_status.containers.current / workspace.plan_status.containers.limit) * 100}%`,
              }"
            ></div>
          </div>
          <div class="d-flex fs-12 ff-l">
            <span class="fw-b">{{ $t('general.navbar.containers_in_use', [workspace.plan_status.containers.current, workspace.plan_status.containers.limit]) }}</span>
            <a href="javascript:void(0)" class="ml-auto fw-n my-auto" @click="upgradePlan">
              {{ $t('general.navbar.upgrade') }}
            </a>
          </div>
        </div>

        <div v-if="!user.read_only || user.is_super_admin" class="divider mb-8"></div>

        <div class="items" v-if="!min">
          <router-link v-if="!user.read_only" :to="{ name: 'profile-settings' }" class="item fs-15 text-secondary d-flex fw-n ff-l w-100">
            <i class="fs-15 fal fa-cog mr-15 my-auto"></i>
            {{ $t('general.navbar.personal_settings') }}
          </router-link>
          <router-link v-if="workspace && workspace.can_edit" :to="{ name: 'workspace-templates', params: { workspaceId: workspace.id } }" class="item fs-15 text-secondary d-flex fw-n ff-l w-100">
            <i class="fs-15 fal fa-file-edit mr-15 my-auto"></i>
            {{ $t('general.navbar.templates') }}
          </router-link>
          <router-link v-if="workspace && workspace.can_edit" :to="{ name: 'workspace-signatures', params: { workspaceId: workspace.id } }" class="item fs-15 text-secondary d-flex fw-n ff-l w-100">
            <i class="fs-15 fal fa-file-signature mr-15 my-auto"></i>
            {{ $t('general.navbar.signatures') }}
          </router-link>
          <router-link v-if="user.is_super_admin" :to="{ name: 'admin-workspaces' }" class="item fs-15 text-secondary d-flex fw-n ff-l w-100">
            <i class="fs-15 fal fa-users-cog mr-15 my-auto"></i>
            {{ $t('general.navbar.admin_dashboard') }}
          </router-link>
        </div>

        <div v-if="!min" class="divider mt-8" />

        <div v-if="!min" class="workspaces">
          <span class="text-uppercase fs-10 fw-b title">{{ $t('general.navbar.my_workspaces') }}</span>
          <div v-if="workspace" class="workspace" :key="workspace.id" @click="switchWorkspace(workspace.id)">
            <div class="avatar mr-15 bg-primary text-white fw-b">
              {{ workspace.company.charAt(0) }}
            </div>
            <span class="fs-14 fw-b my-auto company-text">{{ workspace.company }}</span>
            <span class="fs-12 fw-n text-primary my-auto ml-auto flex-none">
              {{ $t('general.navbar.current_workspace') }}
              <i class="fal fa-check ml-8"></i>
            </span>
          </div>
          <div class="workspace" v-for="other_workspace in filteredWorkspaces" :key="other_workspace.id" @click="switchWorkspace(other_workspace.id)">
            <div class="avatar mr-15 bg-primary text-white fw-b">
              {{ other_workspace.company.charAt(0) }}
            </div>
            <span class="fs-14 fw-b my-auto">{{ other_workspace.company }}</span>
          </div>
          <router-link class="workspace" :to="{ name: 'workspace-create' }">
            <div class="avatar mr-15 bg-body text-white fw-b text-primary">
              <i class="fs-12 fal fa-plus"></i>
            </div>
            <span class="fs-14 fw-b my-auto">{{ $t('general.navbar.create_workspace') }}</span>
          </router-link>
        </div>

        <router-link v-if="user.workspace_ids.length > 1" class="fs-12 fw-n mt-8 d-block" :to="{ name: 'workspace-index' }">
          {{ $t('general.navbar.all_workspaces') }}
        </router-link>

        <div v-if="!user.read_only && !min" class="divider mb-8"></div>

        <div class="logout">
          <a v-if="isImpersonating" class="fs-14 text-body d-flex fw-b ff-l item" href="javascript:void(0)" @click.prevent="stopImpersonating">
            <i class="fs-15 fal fa-sign-out-alt mr-15 my-auto"></i>
            Stop impersonating
          </a>
          <a class="fs-14 text-body d-flex fw-b ff-l item" href="javascript:void(0)" @click="handleLogout">
            <i class="fs-15 fal fa-sign-out-alt mr-15 my-auto"></i>
            {{ $t('general.logout') }}
          </a>
        </div>
      </div>
    </template>
  </dropdown-layout>
</template>

<script>
import DropdownLayout from '@/layouts/dropdown';
import { ElAvatar } from '@/components/elements/_index';
import PaymentUpgradePopup from '@/popups/payment/upgrade';
import UserPasswordPopup from '@/popups/user/password';
import hexToRgba from 'hex-to-rgba';

export default {
  components: { ElAvatar, DropdownLayout },

  props: {
    min: {
      default: false,
      required: false,
      type: Boolean,
    },
  },

  mounted() {
    this.$store.dispatch('auth/listWorkspaces', this.user.id);
  },

  methods: {
    upgradePlan() {
      this.$modal.show(PaymentUpgradePopup, null, {
        adaptive: true,
        height: 'auto',
        width: '900',
        scrollable: true,
      });
    },
    handleLogout() {
      if (this.user.read_only) {
        this.$modal.show(UserPasswordPopup, { callback: this.dispatchLogout }, { adaptive: true, height: 'auto', width: '400' });
      }
      if (!this.user.read_only) {
        this.dispatchLogout();
      }
    },
    dispatchLogout() {
      this.$store.dispatch('auth/logout').then(() => {
        const root = document.documentElement;
        root.style.setProperty('--primary', '#ED8B00');
        root.style.setProperty('--primary-highlight', hexToRgba('#ED8B00', 0.1));
        this.$router.push({ name: 'login' });
      });
    },
    switchWorkspace(id) {
      let previousWorkspaces = localStorage.getItem('last_used_workspaces');
      let previousWorkspacesArray = [];

      if (previousWorkspaces) {
        previousWorkspacesArray.push(previousWorkspaces);
      }

      previousWorkspacesArray.push(id);
      localStorage.setItem('last_used_workspaces', previousWorkspacesArray);

      this.$store.dispatch('workspace/switch', id).then(() => {
        this.$router.push({ name: 'workspace', params: { id: id } });
      });
    },
    stopImpersonating() {
      this.$store.dispatch('auth/unImpersonate').then(() => {
        window.location.href = '/a/users';
      });
    },
  },

  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    workspace() {
      return this.$store.getters['workspace/current'];
    },
    workspaces() {
      return this.$store.getters['auth/workspaces'];
    },
    isImpersonating() {
      return !!this.$store.getters['auth/impersonateToken'];
    },
    filteredWorkspaces() {
      let storageWorkspaces = localStorage.getItem('last_used_workspaces');
      storageWorkspaces = storageWorkspaces ? storageWorkspaces.split(',') : [];

      if (storageWorkspaces.length < 1) {
        return this.workspaces.filter(workspace => (this.workspace ? workspace.id !== this.workspace.id : true)).slice(0, 2);
      }

      storageWorkspaces = storageWorkspaces.reverse();
      storageWorkspaces = [...new Set(storageWorkspaces)];

      let filteredArray = [];
      storageWorkspaces.forEach(id => {
        this.workspaces.forEach(workspace => {
          if (Number(id) === Number(workspace.id)) {
            filteredArray.push(workspace);
          }
        });
      });

      return filteredArray.filter(workspace => (this.workspace ? workspace.id !== this.workspace.id : true)).slice(0, 2);
    },
  },
};
</script>
